import { useMutation, useQueryClient } from 'react-query';
import { useActionLogger } from '@/shared/hooks/action-logger';
import { createMigartorEntity } from '..';
export const useCreateMigratorEntity = () => {
    const queryClient = useQueryClient();
    const { setAction } = useActionLogger();
    return useMutation(createMigartorEntity, {
        onSuccess: () => {
            queryClient.invalidateQueries('GetMigratorList');
            setAction({
                type: 'success',
                message: 'The creation of the migrator entity was successful',
            });
        },
        onError: (error) => {
            setAction({
                type: 'error',
                message: error.toString(),
            });
        },
    });
};
